module.exports = __webpack_public_path__ + "static/media/desbloquear.0724bdcc.svg";